import styled from '@mui/system/styled';
import Box from '@mui/system/Box';

export const Component = styled(Box)(({ theme }) => ({
    padding: '16px',
    display: 'grid',
    gridAutoRows: 'auto',
    gap: '16px',
    backgroundColor: theme.palette.background.default,
    height: 'min-content',
    width: '100%',
    borderRadius: '8px',
}));
